import { render } from "./adminPage.vue?vue&type=template&id=e4b384fc"
import script from "./adminPage.vue?vue&type=script&lang=js"
export * from "./adminPage.vue?vue&type=script&lang=js"

import "./adminPage.vue?vue&type=style&index=0&id=e4b384fc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__